import { constant } from '@config/BaseSetting';
import { toolsRequestHistoryAsync } from '@features/toolsRequestHistory/toolsRequestHistorySlice';
import useLocalStorage from '@hooks/useLocalStorage';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MAILBOX_DEACTIVATION_SERVICE_TYPE = 38;

const initialPagination = { pageIndex: 0, pageSize: 10 };

export default function useMailboxDeactivationHistory() {
  const dispatch = useDispatch();
  const [accessToken] = useLocalStorage(constant.ACCESS_TOKEN_STORAGE);

  const [selectedRow, setSelectedRow] = useState();
  const [pagination, setPagination] = useState(initialPagination);

  const { toolsRequestHistoryState } = useSelector((state) => state.toolsRequestHistory);

  const loadData = () => {
    dispatch(
      toolsRequestHistoryAsync({
        accessToken,
        reset: true,
        serviceType: MAILBOX_DEACTIVATION_SERVICE_TYPE,
        pageNumber: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
      })
    );
  };

  useEffect(loadData, [pagination]);

  useEffect(() => {
    if (!selectedRow) loadData();
  }, [selectedRow]);

  const tableData = useMemo(
    () => toolsRequestHistoryState.data?.map((r) => ({ ...r, isLink: true })),
    [toolsRequestHistoryState.data]
  );

  return {
    fetching: toolsRequestHistoryState.fetching,
    tableData,
    rowsCount: toolsRequestHistoryState.pagination?.TotalCount,
    selectedRow,
    setSelectedRow,
    pagination,
    setPagination,
    handleRefresh: loadData,
  };
}
